import type { ReactNode } from "react";

export function GuidedToast({ message }: { readonly message: string | null }) {
  return (
    <div className={`enrein-guided-toast${message ? " is-show" : ""}`} role="status" aria-live="polite">
      {message}
    </div>
  );
}

export function GuidedLoadingShell({
  message,
  children,
}: {
  readonly message?: string;
  readonly children?: ReactNode;
}) {
  return (
    <div className="enrein-guided-app enrein-guided-app--loading">
      <main className="enrein-guided-loading" id="enrein-guided-main">
        {children ?? <p>{message ?? "Loading Studio…"}</p>}
      </main>
    </div>
  );
}
